import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import SwitchField from "../../../components/Fields/SwitchField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { ItemTypePopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface ItemTypeBomRestriction {
    itemTypeId: number | undefined
    allowedItemTypeId: number
    allowedProductCategoryId: number
    required: boolean
    suggest: boolean
    allowMultiple: boolean
}

const AddItemTypeBomRestrictionPopup: React.FC<ItemTypePopupProps> = ({ show, onHide, itemTypeId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ItemTypeBomRestriction>({
        itemTypeId: itemTypeId,
        allowedItemTypeId: 0,
        allowedProductCategoryId: 0,
        required: false,
        suggest: false,
        allowMultiple: true
    });

    const itemTypes = useSelectListOptions('api/v1/selectlist/ItemTypes', '-- Select item type');
    const productCategories = useSelectListOptions('api/v1/selectlist/ProductCategoryNameTreeLeaves', '-- Select product category');

    function submit() {
        if (formData) {
            DataService
                .create<ItemTypeBomRestriction>(`api/v1/ItemTypeBomRestrictions/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && response.data)
                        setFormData(response.data);

                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'allowedItemTypeId', label: 'Allowed item type', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'allowedProductCategoryId', label: 'Allowed productcategory', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'required', label: 'The Bill-of-Materials must contain an item of this restriction.', labelSize: 8 },
            { name: 'suggest', label: 'Suggest adding an item of this restriction to the Bill-of-Materials.', labelSize: 8 },
            { name: 'allowMultiple', label: 'Allow multiple items of this restriction in the Bill-of-Materials.', labelSize: 8 },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'xl'} title={'Add restriction of what is allowed in the Bill-of-Materials'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('allowedItemTypeId')} options={itemTypes} />
                <SelectListField {...getFieldProps('allowedProductCategoryId')} options={productCategories} />
                <SwitchField {...getFieldProps('required')} />
                <SwitchField {...getFieldProps('suggest')} />
                <SwitchField {...getFieldProps('allowMultiple')} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddItemTypeBomRestrictionPopup;